












































import Vue from 'vue';
import Component from "vue-class-component";
import {Configs} from "./configs";
import MessageComponent from "./components/message-bus.vue";
import MenuComponent from "./components/menu.vue";
import {Client} from "./model/interface/client.interface";

@Component({
    components: {
        MessageComponent,
        MenuComponent
    }
})
export default class App extends Vue {

    private readonly title: string = "Publications";
    private isMenuOpen: boolean = false;
    private user:Client = null;

    private beforeMount() {
        this.$i18n.locale = this.$store.state.lang;
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }
}
